// extracted by mini-css-extract-plugin
module.exports = {"TabList":"TabList__obYKi","TabList__item":"TabList__item__127XU","TabList__item--active":"TabList__item--active__NDiEh","TabList_Count":"TabList_Count__3qPBX"};